import styled from 'styled-components'

export const Slider = styled.input`
  width: 100%;
  margin: 20px 0;
  background-color: transparent;
  -webkit-appearance: none;
  --thumb-size: 40px;
  --thumb-border: 4.7px solid var(--site-background);
  --track-background: rgba(127, 127, 127, 0.2);
  --track-height: 10px;
  transition: all 0.3s ease;
  &:disabled{
    opacity: 0.5;
  }
  &:focus {
    outline: none;
  }
  &::-webkit-slider-runnable-track {
    background: var(--track-background);
    border: 0;
    border-radius: 25px;
    width: 100%;
    height: var(--track-height);
    cursor: pointer;
  }
  &::-webkit-slider-thumb {
    margin-top: -15px;
    width: var(--thumb-size);
    height: var(--thumb-size);
    background: var(--button-background);
    border: var(--thumb-border);
    border-radius: 100%;
    cursor: pointer;
    -webkit-appearance: none;
  }
  &:focus::-webkit-slider-runnable-track {
    background: #d1d1d1;
  }
  &::-moz-range-track {
    background: var(--track-background);
    border: 0;
    border-radius: 25px;
    width: 100%;
    height: var(--track-height);
    cursor: pointer;
  }
  &::-moz-range-thumb {
    width: var(--thumb-size);
    height: var(--thumb-size);
    background: var(--button-background);
    border: var(--thumb-border);
    border-radius: 23px;
    cursor: pointer;
  }
  &::-ms-track {
    background: transparent;
    border-color: transparent;
    border-width: 20.8px 0;
    color: transparent;
    width: 100%;
    height: var(--track-height);
    cursor: pointer;
  }
  &::-ms-fill-lower {
    background: var(--track-background);
    border: 0;
    border-radius: 50px;
  }
  &::-ms-fill-upper {
    background: var(--track-background);
    border: 0;
    border-radius: 50px;
  }
  &::-ms-thumb {
    width: var(--thumb-size);
    height: var(--thumb-size);
    background: var(--button-background);
    border: var(--thumb-border);
    border-radius: 23px;
    cursor: pointer;
    margin-top: 0px;
    /*Needed to keep the Edge thumb centred*/
  }
  &:focus::-ms-fill-lower {
    background: var(--track-background);
  }
  &:focus::-ms-fill-upper {
    background: #d1d1d1;
  }
  /*TODO: Use one of the selectors from https://stackoverflow.com/a/20541859/7077589 and figure out
how to remove the virtical space around the range input in IE*/
  @supports (-ms-ime-align: auto) {
    /* Pre-Chromium Edge only styles, selector taken from hhttps://stackoverflow.com/a/32202953/7077589 */
    & {
      margin: 0;
      /*Edge starts the margin from the thumb, not the track as other browsers do*/
    }
  }
`
